import React from 'react';
import {Outlet} from 'react-router-dom';

function CheckoutView() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default CheckoutView;
